module.exports = __webpack_public_path__ + "img/media-3.6104a64c.png";